import CloseIcon from '@mui/icons-material/Close';

export const CloseButton = ({ handleClose }) =>{
    return(
        <button className='close-button' onClick={handleClose}>
            <CloseIcon style={{fontSize:'16px'}}/>
        </button>
    )
}